<template>
    <div id="app">
        <Header v-show="$route.meta.showHeader" />
        <router-view />
        <Footer v-show="$route.meta.showFooter" />
        <Loading></Loading>
        <div id="watermark" v-show="~names.indexOf($route.name)"></div>
    </div>
</template>

<script>
    import Header from './components/Header/Header.vue'
    import Footer from './components/Footer/Footer.vue'
    import Loading from './components/Loading/Loading.vue'
    import { license } from '../global.config.js'
    import router from './router'
    import { apiListPC } from '@/api'
    import ajax from '@/api/ajax'

    export default {
        name: 'app',
        components: {
            Header,
            Footer,
            Loading,
        },
        data() {
            return {
                names: ['Report'],
            }
        },
        beforeMount() {
            sessionStorage.setItem(
                'license',
                license() || window.config.license || process.env.VUE_APP_LICENSE
            )
        },
        mounted() {
            this.initFontSize()
            if (window.location.href.indexOf('authentication=') == -1) {
                this.$store.dispatch('storeGetClientele')
            }
            this.getEnable()
            setInterval(() => {
                this.getEnable()
            }, 1800000)
            // 1800000
        },
        methods: {
            initFontSize() {
                const htmlDom = document.getElementsByTagName('html')[0]
                let htmlWidth = document.documentElement.clientWidth || document.body.clientWidth
                if (htmlWidth >= 750) {
                    htmlWidth = 750
                }
                if (htmlWidth <= 320) {
                    htmlWidth = 320
                }
                htmlDom.style.fontSize = `${htmlWidth / 7.5}px`
            },
            getEnable() {
                if (window.config.license !== 'pdf') {
                    ajax(apiListPC.getEnable + '?code=' + window.config.license + '&type=2').then(
                        (res) => {
                            if (!res.data) {
                                router.replace('/Empty')
                            } else if (this.$route.name == 'Empty') {
                                router.replace('/Login')
                            }
                        }
                    )
                }
            },
        },
    }
</script>

<style>
    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        width: 100%;
    }
    body {
        height: 100vh !important;
        overflow: auto !important;
    }
</style>
